import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-superadmin-illness-list',
  templateUrl: './superadmin-illness-list.component.html',
  styleUrls: ['./superadmin-illness-list.component.css']
})
export class SuperadminIllnessListComponent implements OnInit {
  @ViewChild('showeditmedcateModal', { static: true } as any) showeditmedcateModal: TemplateRef<any>;
  today = Utils.today;
  cate: any;
  editcate: any;
  editcateid: any;

  constructor(
    private modal: NgbModal,
    private location: Location,
    private service: VproService,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
  ) { }

  create_illness_form: UntypedFormGroup;
  editmedcateform: UntypedFormGroup;


  ngOnInit() {
    this.getIllnessList();

    this.create_illness_form = this._formBuilder.group({

      illness: ['', [Validators.required]],
      ill_status: [''],


    })

    this.editmedcateform = this._formBuilder.group({

      illness: ['', [Validators.required]],
      id: ['', [Validators.required]],
      ill_status: [''],
    })

  }


  // fetch the illness  List

  getIllnessList() {
    this.spinner.show();
    this.service
      .getIllnessList()
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.cate = res;
          console.log("CATEGORY", this.cate);
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }



  // save the illness  List
  saveIllnessList() {

    let data = { ...this.create_illness_form.value };

    console.log("DATA1", data);

    data.ill_status = true;
    console.log("DATA2", data);
    this.spinner.show();
    this.service
      .addIllnessList({ illness_list: [data] })
      .subscribe((result) => {
        this.spinner.hide();
        Utils.showToast("success", "Illness added successfully");
        this.getIllnessList();
      });

  }

  onAccStatusChange = async (index, enable, illness) => {

    let data: any =
    {
      "id": index,
      "illness": illness,
      "ill_status": !enable,
    };
    console.log("list for delete", data);
    this.spinner.show();
    this.service.editIllness(data.id, data).subscribe(
      (res) => {
        this.spinner.hide();
        // // SweetAlert
        Utils.showToast('success', "Illness Deleted successfuly");
        // //this.findPatient(this.page);
        this.getIllnessList();
      },
      (error) => {
        //this.spinner.hide();
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update."
        Utils.showToast('error', message);
      }
    );


  }


  // cate status Changed ends

  // update category name

  updatecate() {

    let data = { ...this.editmedcateform.value };

    data.id = parseInt(data.id);
    data.ill_status = true;


    console.log("Aftter updated value", data);

    this.spinner.show();
    this.service.editIllness(data.id, data).subscribe(
      (res) => {
        this.spinner.hide();
        Utils.showToast('success', "Illness Updated successfuly");
        this.getIllnessList();
      },
      (error) => {
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update profile."
        Utils.showToast('error', message);
      }
    );




  }

  // Display the MODAL

  showeditmedcate(id, illness) {
    this.editcateid = id;
    this.editcate = illness;
    // console.log(this.editcateid);
    // this.fetchservicereport(aid, pid);
    // console.log("showserviceRep   showserviceRep")
    this.editmedcateform.patchValue({
      illness: this.editcate,
      id: this.editcateid
    });

    this.modal.open(this.showeditmedcateModal, { size: 'lg', centered: true, backdrop: 'static' });

  }



}
